import { cn } from '@/shared/lib/cn';

/**
 * Schalter der Gastreise. Er zeigt einen laufenden Wechsel sofort an und ist währenddessen
 * gesperrt; schlägt das Speichern fehl, springt er sichtbar auf den gespeicherten Stand zurück.
 */
export function JourneySwitch({
  label,
  checked,
  pending = false,
  disabled = false,
  onChange,
}: {
  /** Vorgelesen, etwa „Fünf Tage vorher aktiv". */
  label: string;
  checked: boolean;
  pending?: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-label={label}
      aria-checked={checked}
      aria-busy={pending || undefined}
      disabled={disabled || pending}
      onClick={() => onChange(!checked)}
      className="text-ink focus-visible:outline-sage inline-flex min-h-11 items-center gap-2.5 rounded-md text-[12.5px] font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed"
    >
      <span
        aria-hidden
        className={cn(
          'relative h-6 w-10 shrink-0 rounded-full transition-colors',
          checked ? 'bg-sage' : 'bg-ink-faint/60',
          pending && 'opacity-60',
        )}
      >
        <span
          className={cn(
            'absolute top-[3px] size-[18px] rounded-full bg-white shadow-sm transition-[left]',
            checked ? 'left-[19px]' : 'left-[3px]',
          )}
        />
      </span>
      <span aria-hidden className={cn(pending && 'text-ink-soft')}>
        {checked ? 'Aktiv' : 'Inaktiv'}
      </span>
    </button>
  );
}
